import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Link } from 'react-router-dom';
import {
  UserCircleIcon,
  Squares2X2Icon,
  Cog6ToothIcon,
  ArrowLeftOnRectangleIcon,
  WrenchScrewdriverIcon,
  ClipboardDocumentListIcon
} from '@heroicons/react/24/outline';

import { useAuth } from '../../contexts/AuthContext'; // Use actual AuthContext

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const UserMenu = ({ userDisplayName = "My Account", userRole }) => {
  const { logout } = useAuth(); // From AuthContext
  // const user = { displayName: userDisplayName }; // Placeholder for actual user object
  // const logout = () => { console.log("Logout action"); alert("Simulated Logout"); window.location.reload(); }; // Placeholder

  const handleLogout = async () => {
    await logout();
    // For simulation, just log and maybe redirect or refresh
    // logout();
  };

  // let dashboardPath = '/profile-settings'; // Removed unused variable
  // if (userRole === 'admin' || userRole === 'manager') { // Removed unused logic
  //   dashboardPath = '/admin/users'; 
  // }

  return (
    <Menu as="div" className="relative ml-3">
      <div>
        <Menu.Button className="flex items-center max-w-xs rounded-full bg-brand-white text-sm focus:outline-none focus:ring-2 focus:ring-brand-accent-orange focus:ring-offset-2 p-1 hover:bg-gray-100">
          <span className="sr-only">Open user menu</span>
          {/* You can replace this with an img tag if you have user avatars */}
          <UserCircleIcon className="h-8 w-8 rounded-full text-brand-text-dark" />
          {userDisplayName && <span className="ml-2 hidden md:block text-sm font-medium text-brand-text-dark">{userDisplayName}</span>}
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-brand-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none py-1">
          {/* Admin/Manager Specific Links */}
          {(userRole === 'admin' || userRole === 'manager') && (
            <>
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to="/admin/users" 
                    className={classNames(
                      active ? 'bg-gray-100' : '',
                      'group flex items-center px-4 py-2 text-sm text-brand-text-dark w-full'
                    )}
                  >
                    <Squares2X2Icon className="mr-3 h-5 w-5 text-gray-400 group-hover:text-brand-green-dark" aria-hidden="true" />
                    User Management
                  </Link>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to="/admin/service-requests" 
                    className={classNames(
                      active ? 'bg-gray-100' : '',
                      'group flex items-center px-4 py-2 text-sm text-brand-text-dark w-full'
                    )}
                  >
                    <WrenchScrewdriverIcon className="mr-3 h-5 w-5 text-gray-400 group-hover:text-brand-green-dark" aria-hidden="true" />
                    Manage Requests
                  </Link>
                )}
              </Menu.Item>
            </>
          )}

          {/* Client/Staff Specific Link (or all users if staff also need this view) */}
          {(userRole === 'client' || userRole === 'staff') && (
             <Menu.Item>
              {({ active }) => (
                <Link
                  to="/my-service-requests"
                  className={classNames(
                    active ? 'bg-gray-100' : '',
                    'group flex items-center px-4 py-2 text-sm text-brand-text-dark w-full'
                  )}
                >
                  <ClipboardDocumentListIcon className="mr-3 h-5 w-5 text-gray-400 group-hover:text-brand-green-dark" aria-hidden="true" />
                  My Service Requests
                </Link>
              )}
            </Menu.Item>
          )}

          {/* Common Links for all authenticated users */}
          <Menu.Item>
            {({ active }) => (
              <Link
                to="/profile-settings" 
                className={classNames(
                  active ? 'bg-gray-100' : '',
                  'group flex items-center px-4 py-2 text-sm text-brand-text-dark w-full'
                )}
              >
                <Cog6ToothIcon className="mr-3 h-5 w-5 text-gray-400 group-hover:text-brand-green-dark" aria-hidden="true" />
                Profile Settings
              </Link>
            )}
          </Menu.Item>
          <div className="border-t border-gray-100 my-1"></div>
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={handleLogout} // Use actual logout
                className={classNames(
                  active ? 'bg-gray-100' : '',
                  'group flex items-center px-4 py-2 text-sm text-brand-text-dark w-full'
                )}
              >
                <ArrowLeftOnRectangleIcon className="mr-3 h-5 w-5 text-gray-400 group-hover:text-brand-green-dark" aria-hidden="true" />
                Logout
              </button>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default UserMenu;